/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {KTIcon} from '../../../helpers'
import Excel from 'exceljs'
import {useIntl} from 'react-intl'
import {useLang} from '../../../i18n/Metronici18n'
import {contentTypeList, contentViewType} from '../../../../IOTFYEDUTypeList'
import {getListAuthorizedUsers} from '../../../../app/modules/auth/core/_requests'
import {AxiosError} from 'axios'

type Props = {
  className: string
  data: []
  excelData: any
  columns: any
  sorting: any
  sortTable: any
}

const TablesWidget122: React.FC<Props> = ({
  className,
  data,
  excelData,
  columns,
  sorting,
  sortTable,
}) => {
  const intl = useIntl()
  const lang = useLang()
  const [userList, setUserList] = useState<any>([])

  useEffect(() => {
    getUserList()
  }, [])

  const getUserList = async () => {
    try {
      const {data} = await getListAuthorizedUsers()
      setUserList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const generateExcel = (logData: any) => {
    logData = logData || []
    const workbook = new Excel.Workbook()
    const worksheet = workbook.addWorksheet('Content Logs')

    const headers = [
      {header: 'ID', key: 'id', width: 10},
      {header: 'USER', key: 'user', width: 20},
      {header: 'CONTENT TYPE', key: 'contentTitle', width: 20},
      {header: 'CONTENT TITLE', key: 'contentTitle', width: 20},
      {header: 'Duration', key: 'duration', width: 20},
    ]

    worksheet.columns = headers

    logData.forEach((item: any) => {
      worksheet.addRow({
        id: item.id,
        user: item.userId,
        contentTitle: item.contentTitle,
        duration: item.duration,
      })
    })

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'content_logs.xlsx'
      a.click()
      URL.revokeObjectURL(url)
    })
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          {/* 👇 Data Statistics  👇 */}
          <span className='card-label fw-bold fs-3 mb-1'>
            {intl.formatMessage({id: 'REPORTPAGE.DATASTATISTICS'})}
          </span>
          {/* 👆 Data Statistics 👆 */}
          <span className='text-muted mt-1 fw-semibold fs-7'>
            {lang === 'en' ? `More than ${data?.length} record` : `${data?.length}'dan fazla kayıt`}
          </span>
        </h3>
        <div className='card-toolbar'>
          {/* begin::Menu */}
          <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
            <button
              type='button'
              className='btn btn-light-primary me-3'
              onClick={() => generateExcel(excelData)}
            >
              <KTIcon iconName='exit-up' className='fs-2' />
              {intl.formatMessage({id: 'REPORTPAGE.EXPORT'})}
            </button>
          </div>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            //   data-kt-menu-trigger='click'
            //  data-kt-menu-placement='bottom-end'
            //   data-kt-menu-flip='top-end'
          >
            <KTIcon iconName='category' className='fs-2' />
          </button>
          {/* begin::Menu 2 */}
          <div
            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold w-200px'
            data-kt-menu='true'
          >
            {/* begin::Menu item */}
            <div className='menu-item px-3'>
              <div className='menu-content fs-6 text-dark fw-bold px-3 py-4'>Quick Actions</div>
            </div>
            {/* end::Menu item */}
            {/* begin::Menu separator */}
            <div className='separator mb-3 opacity-75'></div>
            {/* end::Menu separator */}
            {/* begin::Menu item */}
            <div className='menu-item px-3'>
              <a href='#' className='menu-link px-3'>
                New Ticket
              </a>
            </div>
            {/* end::Menu item */}
            {/* begin::Menu item */}
            <div className='menu-item px-3'>
              <a href='#' className='menu-link px-3'>
                New Customer
              </a>
            </div>
            {/* end::Menu item */}
            {/* begin::Menu item */}
            <div
              className='menu-item px-3'
              data-kt-menu-trigger='hover'
              data-kt-menu-placement='right-start'
              data-kt-menu-flip='left-start, top'
            >
              {/* begin::Menu item */}
              <a href='#' className='menu-link px-3'>
                <span className='menu-title'>New Group</span>
                <span className='menu-arrow'></span>
              </a>
              {/* end::Menu item */}
              {/* begin::Menu sub */}
              <div className='menu-sub menu-sub-dropdown w-175px py-4'>
                {/* begin::Menu item */}
                <div className='menu-item px-3'>
                  <a href='#' className='menu-link px-3'>
                    Admin Group
                  </a>
                </div>
                {/* end::Menu item */}
                {/* begin::Menu item */}
                <div className='menu-item px-3'>
                  <a href='#' className='menu-link px-3'>
                    Staff Group
                  </a>
                </div>
                {/* end::Menu item */}
                {/* begin::Menu item */}
                <div className='menu-item px-3'>
                  <a href='#' className='menu-link px-3'>
                    Member Group
                  </a>
                </div>
                {/* end::Menu item */}
              </div>
              {/* end::Menu sub */}
            </div>
            {/* end::Menu item */}
            {/* begin::Menu item */}
            <div className='menu-item px-3'>
              <a href='#' className='menu-link px-3'>
                New Contact
              </a>
            </div>
            {/* end::Menu item */}
            {/* begin::Menu separator */}
            <div className='separator mt-3 opacity-75'></div>
            {/* end::Menu separator */}
            {/* begin::Menu item */}
            <div className='menu-item px-3'>
              <div className='menu-content px-3 py-3'>
                <a className='btn btn-primary btn-sm px-4' href='#'>
                  Generate Reports
                </a>
              </div>
            </div>
            {/* end::Menu item */}
          </div>
          {/* end::Menu 2 */}
          {/* end::Menu */}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className=' table align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                {columns.map((item: any, index: number) => {
                  const isDescSorting = sorting.column === item && sorting.order === 'desc'
                  const isAscSorting = sorting.column === item && sorting.order === 'asc'
                  const futureSortingOrder = isDescSorting ? 'asc' : 'desc'
                  return (
                    <th
                      key={index}
                      className={index === 0 ? 'ps-4 min-w-50px rounded-start' : 'min-w-125px'}
                      style={{cursor: 'pointer'}}
                      onClick={() => sortTable({column: item, order: futureSortingOrder})}
                    >
                      {item}
                      {isDescSorting && <span>▼</span>}
                      {isAscSorting && <span>▲</span>}
                    </th>
                  )
                })}
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {data &&
                data.map((item: any, index: number) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className='d-flex align-items-center'>
                          <a className='text-dark fw-bold text-hover-primary mb-1 fs-6 ms-2'>
                            {item.id}
                          </a>
                        </div>
                      </td>
                      <td>
                        <a className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                          {userList.filter((i: any) => i.id === 4)[0]?.fullName || item.userId}
                        </a>
                      </td>
                      <td>
                        <a className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                          {intl.formatMessage({
                            id: `REPORTPAGE.${String(
                              contentTypeList.filter((i) => i.id == item.contentType)[0]?.name
                            )
                              .toLocaleUpperCase()
                              .replace(' ', '_')}`,
                          })}
                        </a>
                      </td>
                      <td>
                        <a className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                          {item.contentTitle}
                        </a>
                      </td>

                      {item?.duration && (
                        <td>
                          <a className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                            {item?.duration}
                          </a>
                        </td>
                      )}
                    </tr>
                  )
                })}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export {TablesWidget122}
